import React from 'react';
import styles from './Heading.module.scss';
import homeStyles from "../../../../styles/Home.module.scss";

const Features = () => {
  return (
    <div className={styles.banner}>
      <div className={styles['features-wrapper']}>
        <div className={styles['content']}>
          <div className={styles["ai-container-header"]}>
            <h1>
              Business Stack to Support{" "}
              <span className={homeStyles["span-gradient"]}>Startup Visions</span>
            </h1>
          </div>
          <p className={styles['supporting-text']}>
            Transform your B2B commerce to keep up with consumer expectations. Plug and Play with our No-code B2B stack to rapidly design, launch and optimize your B2B commerce platform to drive conversion, revenue, and loyalty.
          </p>
        </div>
        <div className={styles['image-container']}>
          <div className={styles['text-2-div']}>
            <div className={styles['icon-bg']}>
              <img src="vision.svg" alt="icon" />
            </div>
            <p className={styles['tagline']}>
              One stop shop for all <span>business needs</span>
            </p>
          </div>
          <img src="b2bstack.webp" alt="B2B Stack" className={styles['main-image']} />
        </div>
      </div>
    </div>
  );
};

export default Features;
